import { render } from "./ResponsibleSalesAgent.vue?vue&type=template&id=1dbdb3cf"
import script from "./ResponsibleSalesAgent.vue?vue&type=script&lang=js"
export * from "./ResponsibleSalesAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__